import request from '@/utils/request'

export function getAccessToken() {
    return request({
        url: '/file/speech/getAccessToken',
        method: 'get'
    })
}